import React from 'react';
import { Empty } from './ui/primitives';
import { DISCORD_INVITE } from './Login';

interface Props {
  notFound?: boolean;
  /** What the missing thing is; plots come from the plot servers rather than the sidebar. */
  kind?: 'world' | 'plot';
  /** Why the list it should be on could not be loaded, when known. */
  detail?: string | null;
}

const NoWorld: React.FC<Props> = ({ notFound, kind = 'world', detail }) => (
  <div className="main2">
    <div className="page" style={{ paddingTop: 80 }}>
      {notFound ? (
        <Empty icon="warn" title={kind === 'plot' ? 'Plot not found' : 'World not found'} big>
          {detail ||
            (kind === 'plot'
              ? "The plot you're looking for doesn't exist on that server, or it isn't yours."
              : "The world you're looking for doesn't exist, or you don't have access to it.")}
        </Empty>
      ) : (
        <Empty icon="globe" title="No world selected" big>
          Your worlds live in the sidebar. Don't see any? Create one in-game with <span className="kbd">/pw</span> or ask in{' '}
          <a href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer">
            Discord
          </a>
          .
        </Empty>
      )}
    </div>
  </div>
);

export default NoWorld;
